import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from "styled-components";

import { BorderlessInputProps } from "./BorderlessInput.types";

const BorderlessInput = styled.input<BorderlessInputProps>`
  padding: 12px 0;
  font-family: Arial;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: ${({ theme }): string => theme.colors.black};
  margin: 0;
  border: none;
  border-bottom: 1px solid ${({ theme }): string => theme.colors.grey};
  outline: 0;
  width: 100%;
  height: 40px;

  :focus,
  :not([value=""]) {
    border-color: ${({ theme }): string => theme.colors.black};
  }

  &.code-input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: ${({ theme }): string => theme.colors.black};
  }

  ${({
    theme,
    hasError,
  }): FlattenInterpolation<ThemeProps<DefaultTheme>> | false =>
    !!hasError &&
    css`
      color: ${theme.colors.red};

      ::placeholder {
        color: ${theme.colors.red};
        opacity: 1;
      }
    `};
`;

export default BorderlessInput;
